// A tiny module-scoped store for the current ID token.
//
// Why not just use the AuthProvider's React context? Because non-React code
// (tool API clients, fetch wrappers) needs to read the token without being
// inside a component tree. The AuthProvider keeps this in sync as the OIDC
// session changes.

let idToken = null;
let username = null;

export const authStore = {
  setSession({ idToken: t, username: u }) {
    idToken = t || null;
    username = u || null;
  },
  clearSession() {
    idToken = null;
    username = null;
  },
  getIdToken() {
    return idToken;
  },
  getUsername() {
    return username;
  },
};
